<script lang="ts">
  import Button from './Button.svelte';
  let { message, retry }: { message: string; retry?: () => void } = $props();
</script>

<section class="inline-state error-state" role="alert">
  <div>
    <strong>Non riesco a caricare questa sezione</strong>
    <p>{message}</p>
  </div>
  {#if retry}
    <Button onclick={retry}>Riprova</Button>
  {/if}
</section>
